exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formula-designer-modal .formula-wrapper{margin-bottom:1.5rem;padding-bottom:1rem}.formula-designer-modal .formula-wrapper .formula-label{min-width:0;display:flex;align-items:center;margin-bottom:.375rem;font-size:.875rem;color:var(--fts-form-label)}.formula-designer-modal .formula-wrapper .formula-label .formula-icon{margin-right:.575rem}.formula-designer-modal .formula-wrapper .formula-label .formula-name{white-space:nowrap;overflow:hidden;flex:1;font-size:.875rem}", ""]);

// exports
